import { NgModule } from '@angular/core';
import { addNavMenuSection, SharedModule } from '@vendure/admin-ui/core';

@NgModule({
  imports: [SharedModule],
  providers: [
    addNavMenuSection({
      id: 'extensions',
      label: 'My Extensions',
      items: [{
        id: 'banners',
        label: 'Banners',
        routerLink: ['/extensions/banners'],
        icon: 'image',
      }],
    },
      'settings'),
  ],
})
export class BannerNavModule { }
